import React from 'react';
import './Divider.scss';

class Divider extends React.PureComponent {
  render() {
    const { text } = this.props;
    return (
      <div className="divider">
        <span>{text}</span>
      </div>
    );
  }
}

Divider.propTypes = {};

export default Divider;
